import { ApiError } from "../../types/ApiError";
import { axios } from "../../lib/axios";
import { Blog } from '../../types/types';
export type BlogsDTO =  Blog

interface BlogsData {
    blogsData: BlogsDTO[];
}
interface BlogsResponse {
    data?: BlogsData;
    error?: ApiError;
}

export const getBlogs = async (): Promise<BlogsResponse> => {
    try {
        const response = await axios.get("/blog/all");
            return { data: { blogsData: response.data } };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error: any) {
        console.error("API Error:", error);
        if (error.response) {
            const apiError: ApiError = {
                statusCode: error.response.status,
                message: error.response.data.message,
                error: error.response.data.error,
            };
            return { error: apiError };
        } else {
            const fallbackError: ApiError = {
                statusCode: 500,
                message: "An unexpected error occurred",
            };
            return { error: fallbackError };
        }
    }
};